import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CustomerData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CustomerDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CustomerDataStore",
			variables: true,
		})
	}
}

export async function load_CustomerData(params) {
  await initClient()

	const store = new CustomerDataStore()

	await store.fetch(params)

	return {
		CustomerData: store,
	}
}
